import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Button } from "components/General/Button";
import { ReactComponent as SearchIcon } from "assets/icons/SearchIcon/searchIcon.svg";
import Loading from "../CircleLoader/CircleLoader";

const InputLoader = styled(Loading)`
  .content {
    margin-bottom: 0;
  }
`;

const useClickOutside = (handler) => {
  const domNode = useRef();

  useEffect(() => {
    const maybeHandler = (event) => {
      if (!domNode.current.contains(event.target || event.target.childNodes)) {
        handler();
      }
    };
    document.addEventListener("mousedown", maybeHandler);
    return () => {
      document.removeEventListener("mousedown", maybeHandler);
    };
  });

  return domNode;
};

const SearchBar = ({
  placeholder,
  value,
  onClick,
  isLoading,
  onChange,
  manualSearch,
  className = "hidden lg:flex",
}) => {
  const [active, setActive] = useState(false);
  const inputRef = useRef();
  const domNode = useClickOutside(() => {
    setActive(false);
  });

  return (
    <div
      className={`h-11 flex w-full mx-auto border border-solid rounded-lg  justify-start items-center relative transition-all duration-150 ease-in-out bg-white !z-0
      ${
        active
          ? " border-blue text-blue"
          : "border-grey-border hover:text-blue hover:border-blue focus:border-blue"
      }
      ${className}`}
      ref={domNode}
      onClick={() => {
        setActive(true);
        inputRef.current.focus();
      }}
    >
      <SearchIcon className="stroke-current absolute h-full flex justify-center items-center left-4" />
      <input
        type="text"
        ref={inputRef}
        className="helv-regular pl-10 pr-4 w-full h-full text-sm text-grey-text placeholder:text-grey-text outline-none focus:outline-none font-normal antialiased bg-transparent"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength="40"
      />
      {isLoading ? (
        <InputLoader
          size="tiny"
          className="mb-0 absolute right-2 my-auto top-0 bottom-0 h-full flex justify-center items-center"
        />
      ) : null}
      {value?.length && !isLoading ? (
        <Button
          className="text-xs text-blue cursor-pointer p-2"
          textClass="!text-xs"
          innerClassName="p-2 !h-[28px]"
          text={manualSearch ? "Search" : "Clear"}
          onClick={(e) => {
            setActive(false);
            e.preventDefault();
            e.stopPropagation();
            if (manualSearch) {
              onClick();
            } else {
              onChange("");
            }
          }}
        />
      ) : null}
    </div>
  );
};

SearchBar.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  manualSearch: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
};
export default SearchBar;
